import http from "@/utils/http";

export function UserApi(url, data, method) {
  let info = {
    url: "user-service/" + url,
    method,
  };

  if (method === "GET") {
    info.params = data;
  } else {
    info.data = data;
  }

  return http(info);
}

export function forgotPassword(email) {
  return http({ url: "user-service/auth/forgot-password", method: "POST", data: { email } });
}

export function verifyResetCode(email, code) {
  return http({ url: "user-service/auth/verify-reset-code", method: "POST", data: { email, code } });
}

export function resetPassword(email, code, password, confirmPassword) {
  return http({ url: "user-service/auth/reset-password", method: "POST", data: { email, code, password, confirmPassword } });
}
